import type { FunctionComponent } from 'react';
import type { TypeContent02Props } from './types';

/**
 * Content02
 */
export const Content02: FunctionComponent<TypeContent02Props> = ({
  className,
  pretitle,
  title,
  children,
  footer,
}: TypeContent02Props) => (
  <div {...(className && { className })}>
    {pretitle && (
      <div className="u-body u-body--xs mb-4 text-center uppercase text-secondary-500">
        {pretitle}
      </div>
    )}

    {title && (
      <div className="u-headline u-headline--h1 mb-10 text-center">{title}</div>
    )}

    {children}

    {footer && <p className="u-body u-body--s mt-10 text-center">{footer}</p>}
  </div>
);
